import {useQuery, gql} from "@apollo/client";

var  FOOTER_CONTACT_INFO = gql`
query FooterContactInfo {
    footerContactInfo(where: {localization: {culture_starts_with: "fa"}}) {
      fax {
        html
      }
      address {
        html
      }
      displayText
      pOBox {
        html
      }
      id
      phone {
        html
      }
      postalCode {
        html
      }
    }
  }
`;

export const useContactInfo = () => {
  const {error, loading, data} = useQuery(FOOTER_CONTACT_INFO);
  return {
    error, data, loading
  };
  } 